import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

function serialize(value) {
  if (value == null) return "-";
  if (typeof value === "object") {
    if (value.name) return value.name;
    try {
      return JSON.stringify(value);
    } catch (e) {
      return String(value);
    }
  }
  return String(value);
}

function serializeWithMask(key, value) {
  const raw = serialize(value);
  if (
    /^(CTR_Number|Bill_of_Lading_Number|BL_Number|VN_Number|Vehicle_Number)$/i.test(
      key
    )
  ) {
    if (!raw || raw === "-") return raw;
    const start = raw.slice(0, 2);
    const end = raw.slice(-2);
    return `${start}${"*".repeat(Math.max(0, raw.length - 4))}${end}`;
  }
  return raw;
}

const TrackingDetail = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const [job, setJob] = useState(state?.job || null);

  useEffect(() => {
    // Persist and restore last viewed job to improve UX on hard refresh
    if (state?.job) {
      try {
        localStorage.setItem("lastJob", JSON.stringify(state.job));
      } catch {}
      setJob(state.job);
      return;
    }
    try {
      const saved = localStorage.getItem("lastJob");
      if (saved) {
        setJob(JSON.parse(saved));
        return;
      }
      const listRaw = localStorage.getItem("lastJobs");
      if (listRaw) {
        const list = JSON.parse(listRaw);
        const match = list.find((x, idx) => {
          const key = String(x?.id || x?._id || x?.Job_Number || idx);
          return key === id;
        });
        if (match) setJob(match);
      }
    } catch {}
  }, [state, id]);

  const [search, setSearch] = useState("");

  const excludeKeys = useMemo(
    () => [
      "Owner",
      "Email",
      "Expiry_Date",
      "Orginal_Document_Import",
      "Recieved_Amount",
      "Contact_Name_2",
      "Associated_InTransit_Record",
      "Remarks",
      "Agent_details",
      "id",
      "Notes_for_Accounts",
      "Quote_No1",
      "Clearing_Agent",
      "ERP_Job_No",
      "Customer_Email",
      "Clearing_Agent_Name",
      "Create_Job_in_Books",
      "Recieved_Date_Deposit",
      "Bill_of_Entry_No_1",
      "Bill_of_Entry_No_2",
      "Debitor",
      "Job_Value",
      "Creditor",
      "Exit_Paper_Recieved",
      "Shippers_Ref_No",
      "Description",
      "Shipper_Invoice_Value",
      "Type_of_Freight",
      "Vessel_Name",
      "Create_Estimate_in_Books",
      "Docs_URL3",
      "Quote_No",
      "Submission_Date",
      "Docs_URL1",
      "Amount",
      "Contact_Name",
    ],
    []
  );

  const pairs = useMemo(() => {
    if (!job) return [];
    const entries = Object.entries(job)
      .filter(([k, v]) => {
        // First, filter out keys that should always be excluded
        if (excludeKeys.includes(k)) return false;

        // Then, filter out entries with no data
        return (
          v !== null && v !== undefined && v !== "" && v !== "-" && v !== 0
        );
      })
      .map(([k, v]) => [k, serializeWithMask(k, v)]);
    const q = search.trim().toLowerCase();
    if (!q) return entries;
    return entries.filter(([k, v]) => `${k} ${v}`.toLowerCase().includes(q));
  }, [job, search, excludeKeys]);

  return (
    <div className="max-w-5xl mx-auto px-6 py-8">
      <div className="flex items-center justify-between mb-4">
        <button onClick={() => navigate(-1)} className="text-[#003F75]">
          Back
        </button>
        <h1 className="text-xl font-semibold text-gray-900">
          Project #{job?.Job_Number || job?.ERP_No || id}
        </h1>
        <div />
      </div>

      <div className="text-[#003F75] mb-4">{job?.Job_Status || "-"}</div>

      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search fields"
        className="w-full border border-gray-200 rounded-lg px-3 py-2 mb-4"
      />

      <div className="bg-white border border-gray-200 rounded-xl">
        <div className="divide-y divide-gray-100">
          {pairs.map(([k, v]) => (
            <div key={k} className="flex px-4 py-2">
              <div className="w-60 text-gray-500">{k}</div>
              <div className="flex-1 text-gray-900 break-all min-w-0">{v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrackingDetail;

// shipper name and supplier invoice number to be under each other
